export const INSTRUMENTS = [
  // CEDEARs
  { ticker: 'SPY',  name: 'CEDEAR ETF S&P 500',     type: 'cedear' },
  { ticker: 'QQQ',  name: 'CEDEAR ETF Nasdaq 100',   type: 'cedear' },
  { ticker: 'AAPL', name: 'CEDEAR Apple',             type: 'cedear' },
  { ticker: 'GOOGL',name: 'CEDEAR Alphabet',          type: 'cedear' },
  { ticker: 'AMZN', name: 'CEDEAR Amazon',            type: 'cedear' },
  { ticker: 'MSFT', name: 'CEDEAR Microsoft',         type: 'cedear' },
  { ticker: 'TSLA', name: 'CEDEAR Tesla',             type: 'cedear' },
  { ticker: 'NVDA', name: 'CEDEAR Nvidia',            type: 'cedear' },
  { ticker: 'MELI', name: 'CEDEAR MercadoLibre',      type: 'cedear' },
  { ticker: 'BRKB', name: 'CEDEAR Berkshire Hathaway',type: 'cedear' },
  // Acciones argentinas
  { ticker: 'YPF',  name: 'YPF S.A.',                type: 'accion' },
  { ticker: 'GGAL', name: 'Grupo Galicia',            type: 'accion' },
  { ticker: 'BMA',  name: 'Banco Macro',              type: 'accion' },
  { ticker: 'PAMP', name: 'Pampa Energía',            type: 'accion' },
  { ticker: 'TXAR', name: 'Ternium Argentina',        type: 'accion' },
  { ticker: 'LOMA', name: 'Loma Negra',               type: 'accion' },
  { ticker: 'SUPV', name: 'Grupo Supervielle',        type: 'accion' },
  { ticker: 'TECO2',name: 'Telecom Argentina',        type: 'accion' },
  // ONs destacadas
  { ticker: 'RVS1O',name: 'ON Raízen 2027',          type: 'on' },
  { ticker: 'YCA6O',name: 'ON YPF 2026',             type: 'on' },
  { ticker: 'PAE2O',name: 'ON Pan American 2027',    type: 'on' },
  // Cripto
  { ticker: 'BTC',  name: 'Bitcoin',                 type: 'crypto' },
  { ticker: 'ETH',  name: 'Ethereum',                type: 'crypto' },
  { ticker: 'USDT', name: 'Tether (stablecoin)',     type: 'crypto' },
  // Instrumentos de renta
  { ticker: 'CAUCION_1D', name: 'Caución 1 día',    type: 'caucion' },
  { ticker: 'CAUCION_7D', name: 'Caución 7 días',   type: 'caucion' },
]
